import type { NotifyPort } from '@/features/messages/domain/notify'
import type { OrgTeamPort } from '../domain/member'

const deleteTeam = async (
	port: OrgTeamPort,
	id: string,
	notify: NotifyPort,
): Promise<boolean> => {
	try {
		await port.deleteTeam(id)
		notify.success('hr.teamDeleted')
		return true
	} catch {
		notify.error('hr.teamDeleteFailed')
		return false
	}
}

export { deleteTeam }
